import { render, staticRenderFns } from "./SettList.vue?vue&type=template&id=33a0bf74&scoped=true&"
import script from "./SettList.vue?vue&type=script&lang=js&"
export * from "./SettList.vue?vue&type=script&lang=js&"
import style0 from "./SettList.vue?vue&type=style&index=0&id=33a0bf74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a0bf74",
  null
  
)

export default component.exports